import React from 'react';

import { gql, useMutation } from '@apollo/client';
import { Container, Divider, Stack } from '@mui/material';
import { LoadingButton } from '../components';

const testPushNotificationGql = gql(`
  mutation testPushNotification {
    testPushNotification {
      success
      errors
    }
  }
`);

const TestNotificationButton = () => {
  const [testPushNotificationMutation] = useMutation(testPushNotificationGql);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const submitHandler = React.useCallback(async () => {
    setIsSubmitting(true);
    await testPushNotificationMutation();
    setIsSubmitting(false);
  }, [testPushNotificationMutation]);

  return (
    <LoadingButton
      disabled={isSubmitting}
      loading={isSubmitting}
      color="inherit"
      variant="outlined"
      onClick={submitHandler}
    >
      Test Noti
    </LoadingButton>
  );
};

const PlaygroundPage = () => (
  <Container maxWidth="md" sx={{ paddingY: 2 }}>
    <h1>Playground</h1>

    <Divider />

    <Stack gap={2} flexDirection="row" alignItems="center" paddingY={1}>
      Test Noti Button: <TestNotificationButton />
    </Stack>

    <Divider />
  </Container>
);

export default PlaygroundPage;
